import { type AnchorHTMLAttributes, forwardRef } from 'react'
import { checkUrlType, getSafeLinkUrl } from 'src/utils/urlCheck'

export interface SafeLinkProps
  extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  /**
   * The URL to navigate to
   */
  href: string
  /**
   * Tracking source
   */
  source?: string
}

export const SafeLink = forwardRef<HTMLAnchorElement, SafeLinkProps>(
  function SafeLink({ href, source, ...props }, ref) {
    const urlType = checkUrlType(href)

    const hrefTo = urlType === 'official' ? href : getSafeLinkUrl(href, source)

    return (
      <a ref={ref} href={hrefTo} {...props}>
        {href}
      </a>
    )
  },
)
